import { realBricksApi } from "../../utils/axiosInterceptors";

export const sendVerificationLink = async(data) => {
    const response = await realBricksApi.post(`/api/v1/user/forgot-pin-password-link`, data);
    return response.data;
}

export const changePasswordApi = async(data) => {
    const response = await realBricksApi.put(`/api/v1/user/password`, data);
    return response.data;
}